import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { ISSUE_TYPE_HIERARCHY_LEVEL } from '@atlassian/jira-issue-shared-types/src/common/types/issue-hierarchy-type.tsx';
import {
	ISSUE_TYPE,
	ISSUE_TYPE_GQL_FIELD,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ExportForTesting - Not used in Bento; added for parity with legacy
export const deprecatedAttributes = {
	avatarId: 0,
	self: '', // @deprecated - TODO: Make optional in a separate ticket
};

// @ts-expect-error TODO JPX-157
export const getSystemAggJiraIssueType = (fields) => {
	const issueTypeField = fields?.find(
		// @ts-expect-error TODO JPX-157
		(edge) =>
			edge?.node != null &&
			edge.node.__typename === ISSUE_TYPE_GQL_FIELD &&
			edge.node.type === ISSUE_TYPE,
	)?.node;

	if (
		issueTypeField == null ||
		issueTypeField.__typename !== ISSUE_TYPE_GQL_FIELD ||
		issueTypeField.type !== ISSUE_TYPE
	) {
		throw new Error(
			`Failed to get system issue type: ${ISSUE_TYPE_GQL_FIELD} with ${ISSUE_TYPE} 'fieldId' and 'type' not found [${JSON.stringify(
				fields ?? '',
			)}]`,
		);
	}

	if (issueTypeField.issueType == null) {
		throw new Error(
			`Failed to get system issue type: ${ISSUE_TYPE_GQL_FIELD}.issueType is missing [${JSON.stringify(
				issueTypeField,
			)}]`,
		);
	}

	return issueTypeField.issueType;
};

// @ts-expect-error TODO JPX-157
export const transformJiraIssueTypeToLegacyIssueType = (issueType) => {
	const id = issueType.issueTypeId;

	const hierarchyLevel = issueType.hierarchy?.level;
	return {
		...deprecatedAttributes,
		id,
		iconUrl: issueType.avatar?.medium ?? '', // Legacy uses `medium` size
		name: issueType.name,
		description:
			'description' in issueType && issueType.description != null ? issueType.description : '',
		hierarchyLevel,
		subtask: hierarchyLevel === ISSUE_TYPE_HIERARCHY_LEVEL.SUBTASK_LEVEL,
	};
};

export const transformAggIssueTypeToLegacyField: FieldTransformer<typeof ISSUE_TYPE> = (node) => {
	if (node.type !== ISSUE_TYPE || node.issueType == null) {
		throw new Error(
			`Failed to transform ${ISSUE_TYPE_GQL_FIELD}: type is not ${ISSUE_TYPE} or 'issueType' is empty [${JSON.stringify(
				node,
			)}]`,
		);
	}

	return {
		...transformAggNodeToLegacyField(node),
		value: transformJiraIssueTypeToLegacyIssueType(node.issueType),
		schema: {
			configuration: null,
			custom: null,
			items: null,
			renderer: PLAIN_TEXT,
			system: ISSUE_TYPE,
			type: ISSUE_TYPE,
		},
	};
};
